<template>
    <div class="lms lms__user_workspaces_list">
        <div class="lms__user_workspaces_list_header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="lms__user_workspaces_list_title">
                            <component-title :size="'extra-large'">{{ $t('lms.workspace.title.welcomeBack') }}</component-title>
                        </div>
                        <div class="lms__user_workspaces_list_description">
                            <template v-if="user.isInpersonated()">
                                <component-text>In order to access another workspace login to another learner profile</component-text>
                            </template>
                            <template v-else>
                                <component-text>{{ $t('lms.workspace.title.pleaseChoose') }}</component-text>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="lms__user_workspaces_list_main">
            <template v-if="!user.isInpersonated()">
                <template v-if="rawItems.length && rawItems">
                    <div class="container">
                        <div class="lms__user_workspaces_list_workspaces_list_main">
                            <template v-for="customer in rawItems">
                                <div class="lms__user_workspaces_list_workspaces_list_main_customer">
                                    <component-title
                                        :size="'large'"
                                        :raw="true"
                                    >{{ customer.name }}
                                    </component-title>
                                    <lms-user-workspaces-list-grid
                                        :items="customer.workspaces"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <component-empty-state
                        :item="$t('lms.workspace.search.event')"
                        :title="$t(`lms.workspace.search.youAreNotAssigned`)"
                        :content="''"
                        :submit-button-active="false"
                    />
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import LmsUserWorkspacesListGrid from '@/components/lms/user/workspaces/LmsUserWorkspacesListGrid'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentText from '@/components/default/shared/ComponentText'
import { User } from '@/User'

export default {
  name: 'lms-user-workspace-list',
  components: { ComponentText, ComponentTitle, LmsUserWorkspacesListGrid, ComponentEmptyState },
  data () {
    return {
      outputItems: [],
      user: new User()
    }
  },
  computed: {
    rawItems () {
      return this.$store.getters.getLmsUserWorkspacesGroupedByCustomer
    }
  },
  methods: {
    setFilterResult (data) {
      this.outputItems = data
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/workspaces/_lmsuserworkspacelist.scss";
</style>
